import ProductDiscountPrice from './ProductDiscountPrice';

export default ProductDiscountPrice;
